import React, { Component } from 'react';
// icons
import IconStepOne from 'react-icons/lib/md/looks-one';
import IconStepTwo from 'react-icons/lib/md/looks-two';
import IconStepThree from 'react-icons/lib/md/looks-3';

// components
import AddPaymentButton from '../../components/Buttons/AddPaymentMethod';
import AddPropertyButton from '../../components/Buttons/AddProperty';
import Loading from '../../components/Shared/Loading';
import PaymentInfo from '../../components/Payment/PaymentInfo';
// stores
import UserStore from '../../stores/UserStore';

import Page from '../Page/Empty';

class EmptyProperties extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ready: !!UserStore.user.stripeCustomerId,
      step: 1,
    };

    this.steps = [
      {
        icon: <IconStepOne />,
        text: <div>Activate your account by adding a payment method. The first month is on us! (aka free!)</div>,
        renderButton: () => {
          return (
            UserStore.user.hasPaymentMethod() ?
            <PaymentInfo source={UserStore.user.stripeSource} color="#00bc99" /> :
            <AddPaymentButton onSave={this.onPaymentSave} />);
        }
      },
      {
        icon: <IconStepTwo />,
        text: <div>Tell us a little about your property to get a <b>Passcode.io</b> number.</div>,
        renderButton: () => {
          return <AddPropertyButton disabled={!UserStore.user.hasPaymentMethod()} />
        }
      },
      {
        icon: <IconStepThree />,
        text: <div>Give your <b>Passcode.io</b> number to your building manager, add passcodes, and start using them!</div>
      },
    ];
  }

  componentDidMount() {
    if (!UserStore.user.stripeCustomerId) {
      UserStore.waitFor("stripeCustomerId").then((stripeCustomerId) => {
        this.setState({ ready: true });
      });
    }
  }

  render() {
    const {
      ready,
    } = this.state;

    return (
      <Page title="Welcome to Passcode!">
        <div className="Properties-empty-container">
          {
            ready ?
            this.renderSteps() :
            this.renderLoading()
          }
        </div>
      </Page>
    );
  }

  renderSteps = () => {
    let stepNodes = this.steps.map((step, index) => {
      return (
        <div key={index} className="Properties-empty-step">
          <div className="Properties-empty-step-icon">{step.icon}</div>
          <div className="Properties-empty-step-text">
            { step.text }
            { step.renderButton &&
              <div className="Properties-empty-step-button">{step.renderButton()}</div>
            }
          </div>
        </div>
      );
    });
    return (
      <div className="Properties-empty-steps">
        {stepNodes}
      </div>
    );
  }

  renderLoading = () => {
    let content = (
      <div className="Properties-empty-loading theme-color">
        <Loading />
      </div>
    );

    // if (ready) {
    //   const trigger = (
    //     <Button bsStyle="link">
    //       <div className="Properties-empty-getStarted theme-color">
    //         <span>Get Started <IconGo style={{verticalAlign: "sub"}} /></span>
    //       </div>
    //     </Button>
    //   );
    //   content = (<AddPropertyButton trigger={trigger}/>);
    // }

    return content;
  }

  onPaymentSave = (stripeSource) => {
    this.setState({ step: 2 });
  }
}

export default EmptyProperties;


// WEBPACK FOOTER //
// ./src/pages/Properties/EmptyProperties.js